import React from "react";
import Adapter from "../../communications/Adapter";
import { connect } from "react-redux";

interface IState {
  backdrop: boolean;
  errorAlert: boolean;
  alertErrors: string[];
  flow: string;
}
class SmsViewer extends React.Component<any, IState> {
  state: IState = {
    backdrop: true,
    errorAlert: false,
    alertErrors: [],
    flow: "normal",
  };
  componentDidMount() {
    document.title = "Sms Viewer";
  }

  handleCloseError() {
    this.setState({ errorAlert: false });
  }

  render() {
    const { user } = this.props;

    return <div>{user ? <Adapter /> : ""}</div>;
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SmsViewer);
